module.exports = __webpack_public_path__ + "static/media/logo-banesco.ac825e77.svg";